<template>
    <div class="flex flex-col h-full relative">

        <main class="h-full flex flex-col items-center relative">
            <!-- soru -->
            <div class="h-4/6 pb-3 lg:pb-6 2xl:pb-10 w-full flex flex-col items-center justify-end font-bold">
                <div
                    class="flex items-center justify-center games-elements-text-color-question"
                    :class="phoneScreen.landscape && 'text-3xl lg:text-5xl' || 'text-3xl lg:text-4xl'"
                >
                        {{selected_element.name}}
                </div>
            </div>
            <!-- cevap -->
            <div class="h-4/6 w-full mt-6">
                <div class="flex justify-center item-center space-x-5">
                    <div
                        v-for="c in choices"
                        :key="c"
                        class="cursor-pointer "
                        @click="canAnswer && setAnswer(c)">

                        <div
                            :class="choiceClass(selected_element['font-size'] ? selected_element['font-size'] : 0)">
                            <b v-html="canAnswer ? c : ''" />
                        </div>

                    </div>
                </div>

                <!-- puanı basalım -->
                <div class="flex items-center justify-center space-x-2 games-elements-text-color-question" :class="phoneScreen.landscape  && 'mt-3 lg:mt-6 2xl:mt-10' || 'mt-10'">
                    <div class="text-right text-sm lg:text-3xl font-bold text-black">
                        {{ notification?.praise }}
                    </div>
                    <div class="transform -rotate-12 text-xs font-bold lg:text-lg "
                        v-if="notification?.point">+{{ notification?.point }}
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script setup>
import {ref, watch, computed} from "vue"
import useSound from '../../sounds'
import {useScreen} from 'vue-screen'
import i18next from 'i18next';

const emit = defineEmits(['screen', 'add_point'])
const props = defineProps(['gamer', 'first_multiplier', 'second_multiplier', 'volume', 'time', 'elements'])

const selected_element = ref(null)

const choices = ref([])
const notification = ref([])
const selectedAnswer = ref(null);
const {soundStart, soundSetVolume} = useSound({files_url:i18next.t('files_url')})
const phoneScreen = useScreen()
const lenWrong = ref(0)
const timeWrong = ref(0)
const canAnswer = ref(true)
const selectArr = ref([])
const start = () => {
    getQuestion()
}

soundSetVolume(props.volume)

watch(props, (props, _) => {
    if (timeWrong.value - props.time > 3 && timeWrong.value > 0) {
        canAnswer.value = true
        lenWrong.value = 0
        timeWrong.value = 0
        notification.value = {
            praise: i18next.t('elements_info_continue'),
            point: 0
        }
    } else {
        if (timeWrong.value > 0) {
            const remainingTime = (4 - (timeWrong.value - props.time));
            if (remainingTime < 4) {
                notification.value = {
                    praise: i18next.t('elements_info_wait', {time: remainingTime}),
                    point: 0
                }
            }
        }
    }
})


const setAnswer = (answer) => {
    const notificationArr = []
    notificationArr.push(i18next.t('elements_info_notification_1'))
    notificationArr.push(i18next.t('elements_info_notification_2'))
    notificationArr.push(i18next.t('elements_info_notification_3'))
    notificationArr.push(i18next.t('elements_info_notification_4'))
    selectedAnswer.value = answer;

    if (answer == selected_element.value.formula) {
        soundStart(0)
        lenWrong.value = 0

        const period = (props.gamer.bestAnswer + 1) % 4;
        const newPoint = period == 0 ? 30 : 10;
        const newGamer = {
            ...props.gamer,
            bestAnswer: props.gamer.bestAnswer + 1,
            point: props.gamer.point + newPoint
        }
        emit('add_point', newGamer)

        const notificationKey = newGamer.bestAnswer > notificationArr.length ? notificationArr.length - 1 : newGamer.bestAnswer - 1;

        notification.value = {
            praise: notificationArr[notificationKey],
            point: newPoint
        }
    } else {
        soundStart(1)
        const newGamer = {
            ...props.gamer,
            bestAnswer: 0,
        }

        emit('add_point', newGamer)
        notification.value = {
            praise: i18next.t('elements_info_error'),
            point: 0
        }
        lenWrong.value = lenWrong.value + 1

        if (lenWrong.value == 3) {
            timeWrong.value = props.time
            canAnswer.value = false
            notification.value = {
                praise: i18next.t('elements_info_wait', {time: 3}),
                point: 0
            }
        }
    }
    getQuestion()
}



const setChoose = () => {
    const answer = selected_element.value.formula

    const newArr = [...selected_element.value.choice]

    const selectedArr = shuffle(toUniqueArray(newArr)).filter(i => i != answer);
    choices.value = shuffle([selectedArr[0], answer])
}


const toUniqueArray = (a) => {
    var newArr = [];
    for (var i = 0; i < a.length; i++) {
        if (newArr.indexOf(a[i]) === -1) {
            newArr.push(a[i]);
        }
    }
    return newArr;
}

const setScreen = (screen) => {
    emit('screen', screen)
}



const getQuestion =  () => {
    if (selectArr.value.length == 0) {
        selectArr.value = [...shuffle(props.elements)]
    }


    // let selected = Math.floor(Math.random() * props.elements.length)

    // selected_element.value = props.elements[selected]
    selected_element.value = selectArr.value[0]
    selectArr.value.shift();
    setChoose()
}

const shuffle = (array) => {
    let currentIndex = array.length, randomIndex;

    // While there remain elements to shuffle...
    while (currentIndex != 0) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex], array[currentIndex]];
    }
    return array;
}


// :class="phoneScreen.landscape
//                             && 'h-20 w-24 lg:h-24 lg:w-32 text-lg lg:text-2xl text-black text-center'

//                             || 'h-24 w-24 lg:h-24 lg:w-28 text-2xl lg:text-xl text-black'"

const choiceClass = (size) => {

    let landscapeSize = [];
    landscapeSize[0] = "text-lg lg:text-xl";
    landscapeSize[1] = "text-base";

    let portraitSize = [];
    portraitSize[0] = "text-2xl lg:text-xl";
    portraitSize[1] = "text-base lg:text-xl";

    return `${phoneScreen.landscape ? landscapeSize[size] : portraitSize[size]} text-black text-center games-elements-gridant rounded-full px-12 py-3`
}

start()

</script>
